import {GridRow} from '@mui/x-data-grid';
import clsx from 'clsx';

export default function GridRowCustom(props: any) {
  const {className, index, ...other} = props;
  return <GridRow index={index} className={clsx(className, index % 2 === 0 ? 'Mui-odd' : 'Mui-even')} {...other} />;
}
